import { useRouter } from "next/router";
import { useEffect } from "react";
import useNavigatorOnline from "use-navigator-online";
import { toast } from "~served/ui-comps/toast";
import { useIsConnectedToServer } from "~/store";

export const OfflineDialog = () => {
	const router = useRouter();
	const { isOffline } = useNavigatorOnline();

	const isConnectedToServer = useIsConnectedToServer();

	useEffect(() => {
		if (!isOffline) toast.dismiss("offline-toast");
		if (isConnectedToServer) toast.dismiss("disconnected-toast");
	}, [isConnectedToServer, isOffline]);

	if (router.pathname.includes("/offline")) {
		toast.dismiss("offline-toast");
		toast.dismiss("disconnected-toast");

		return null;
	}

	if (isOffline)
		toast.loading("No internet connection 🚫😥", {
			description: "You are currently offline. Check your device connection.",
			id: "offline-toast",
		});

	if (!isOffline && !isConnectedToServer)
		toast.loading("Lost real time connection 🚫😥", {
			description:
				"You might need to refresh some parts of the app to see the latest data.",
			id: "disconnected-toast",
		});

	return null;
};
